import { render, staticRenderFns } from "./BraceEditor.vue?vue&type=template&id=58f76463&"
import script from "./BraceEditor.vue?vue&type=script&lang=js&"
export * from "./BraceEditor.vue?vue&type=script&lang=js&"
import style0 from "./BraceEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports